// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/ApplicationsSection/ApplicationsSection.css
// module id = 965
// module chunks = 0